export default __webpack_public_path__ + "static/thumb-landscape-31642821c77829ddb2777ce64da747df.jpg";